// extracted by mini-css-extract-plugin
export var fadeInOut = "_28-3";
export var icon = "_28-4";
export var savedIndicator = "_28-2";
export var savingIndicator = "_28-0";
export var spin = "_28-1";